var map = {
	"./review-small1.png": 88950,
	"./review-small2.png": 70573,
	"./review-small3.png": 30628,
	"./review-small4.png": 12283,
	"./review-small5.png": 98066,
	"./review1.png": 9560,
	"./review2.png": 55315,
	"./review3.png": 106,
	"./review4.png": 83333,
	"./review5.png": 444,
	"./review6.png": 58551,
	"./review7.png": 12974,
	"./review8.png": 44889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34766;